"use client";

import { memo } from "react";
import { Typography } from "@/components/ui/typography";
import Link, { LinkProps } from "next/link";
import { cn } from "@/lib/utils";

type LanguageLabelLinkProps = {} & React.ComponentProps<"a"> & LinkProps;

const LanguageLabelLink = ({
  href,
  children,
  className,
}: LanguageLabelLinkProps) => {
  return (
    <Link
      href={href}
      className={cn(
        "inline-flex p-4 rounded-2xl bg-white border border-blue-200 text-semantic-text-primary transition-colors lg:px-6 lg:text-gray-600 lg:border-frosted-blue hover:border-blue-300",
        className
      )}
    >
      <Typography variant="labelMd" asChild className="lg:text-xl lg:leading-[150%] lg:font-medium">
        <span>{children}</span>
      </Typography>
    </Link>
  );
};

export default memo(LanguageLabelLink);
